import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'ngx-preview-dialog',
  templateUrl: './preview-dialog.component.html',
  styleUrls: ['./preview-dialog.component.scss'],
})
export class PreviewDialogComponent implements OnInit {
  @Input() file: string = '';
  @Input() type: string = '';

  isImage = false;
  isPdf = false;
  safePdfUrl: SafeResourceUrl | null = null;

  constructor(
    protected dialogRef: NbDialogRef<PreviewDialogComponent>,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    if (!this.file) return;

    const isBase64 = this.file.startsWith('data:');

    if (isBase64) {
      if (this.file.includes('application/pdf')) {
        this.isPdf = true;
        this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.file,
        );
      } else if (this.file.includes('image/')) {
        this.isImage = true;
      }
    } else {
      const ext = this.file.split('.').pop()?.toLowerCase();
      const fileType = this.type ? this.type.toLowerCase() : ext;

      this.isPdf = fileType === 'pdf';
      this.isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(
        fileType || '',
      );

      if (this.isPdf) {
        this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.file,
        );
      }
    }
  }

  close() {
    this.dialogRef.close();
  }
}
